import { useQuery } from "@tanstack/react-query";
import type { DiscoveryInfluencerProfile } from "../types/discoveryProfile.types";
import { discoveryRepository } from "../repositories/discovery.repository";
import { transformProfileData } from "../services/discoverySearch.service";
import { discoveryKeys } from "../services/discovery.keys";

export function useDiscoveryInfluencer(handle: string) {
  const cleanHandle = handle ? handle.replace("@", "") : "";

  return useQuery({
    queryKey: discoveryKeys.profile(cleanHandle),
    queryFn: async (): Promise<DiscoveryInfluencerProfile | null> => {
      const data = await discoveryRepository.getProfileByHandle(cleanHandle);
      if (!data) return null;
      return transformProfileData(data);
    },
    enabled: !!cleanHandle,
  });
}
